import type { DragEndEvent } from "@dnd-kit/core";

import { atom } from "nanostores";

import type { ExpandCollapseApi } from "../../types/expand-collapse-types";

import { GraphLayout } from "../../api/types.gen.ts";
import { DragData } from "../../types/graph-ui.ts";
import { $router } from "../router.ts";

export const $zoomLevel = atom<number>(1);
export const $cytoscapeInstance = atom<cytoscape.Core | null>(null);
export const $expandCollapseApi = atom<ExpandCollapseApi | null>(null);
export const $collapsedClusterIds = atom<Set<string>>(new Set());
export const $graphDragEvent = atom<DragEndEvent | null>(null);
export const $isDragInProgress = atom<boolean>(false);
export const $dragData = atom<DragData | null>(null);
export const $isPanelTransitioning = atom<boolean>(false);
export const $graphLayout = atom<GraphLayout>(GraphLayout.FCOSE);

$router.subscribe(() => {
  $graphDragEvent.set(null);
  $isDragInProgress.set(false);
  $dragData.set(null);
  $expandCollapseApi.set(null);
  $collapsedClusterIds.set(new Set());
  $graphLayout.set(GraphLayout.FCOSE);
});

export const zoomToFit = (): void => {
  const elements = $cytoscapeInstance?.get()?.elements();

  if (!elements) return;

  setTimeout(() => {
    $cytoscapeInstance?.get()?.animate({
      duration: 100,
      fit: { eles: elements, padding: 20 },
    });
  }, 500);
};

export const zoomIn = (): void => {
  const cytoscapeInstance = $cytoscapeInstance.get();
  if (!cytoscapeInstance) return;

  const currentZoom = cytoscapeInstance.zoom();
  const zoomSpeed = 0.2; // 20% increase
  const maxZoom = 2;

  const newZoom = Math.min(maxZoom, currentZoom * (1 + zoomSpeed));

  cytoscapeInstance.animate({
    duration: 200,
    zoom: newZoom,
  });
};

export const zoomOut = (): void => {
  const cytoscapeInstance = $cytoscapeInstance.get();
  if (!cytoscapeInstance) return;

  const currentZoom = cytoscapeInstance.zoom();
  const zoomSpeed = 0.2; // 20% decrease
  const minZoom = 0.05;

  const newZoom = Math.max(minZoom, currentZoom * (1 - zoomSpeed));

  cytoscapeInstance.animate({
    duration: 200,
    zoom: newZoom,
  });
};
